<template>
    <div>
        <v-list-item dense v-ripple @click="$emit('click')" three-line>
            <v-list-item-avatar>
                <v-avatar color="grey lighten-3">
                    <v-icon :color="avatarColor">{{avatarIcon}}</v-icon>
                </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{activity.code_f}} - {{activity.summary}}</v-list-item-title>
                <v-list-item-subtitle>{{activity.details}}</v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">
                    <span class="me-2">Date: {{formatTime(activity.created_at)}}</span>
                    <span v-if="activity.due_date">Due Date: {{formatTime(activity.due_date)}}</span>
                </v-list-item-subtitle>             
            </v-list-item-content>
            <v-chip class="me-2" color="error" outlined small v-if="overdue && open">Overdue</v-chip>
            <v-chip class="me-2" color="grey" outlined small>{{activity.touch_point}}</v-chip>
            <v-chip class="me-2" color="grey" outlined small>{{activity.type}}</v-chip>
        </v-list-item>
        <v-divider v-if="!lastItem"></v-divider>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: "CustomerActivityItem",
    props: ["activity", "lastItem"],
    data() {
        return {

        }
    },
    computed: {
        open() {
            return this.activity.is_open;
        },
        avatarColor() {
            if(this.overdue && this.open) return "error";
            else return this.open ? "success" : "grey";
        },
        avatarIcon() {
            return this.open ? "mdi-label" : "mdi-lock"
        },
        overdue() {
            return this.activity.is_overdue;
        }
    },
    methods: {
        formatTime(time) {
            return moment(time).format("YYYY-MM-DD");
        }
    }
}
</script>
